module.exports = __webpack_public_path__ + "assets/media/sf-small.75995b0c.svg";